import {
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Close, GetApp, Visibility } from "@material-ui/icons";
import React from "react";
import pdfFileIcon from "../../../../../assets/pdfFileIcon.svg";
import ReportImageCard from "./ReportImageCard";
import ReportImagePreviewItem from "./ReportImagePreviewItem";

const ReportDisplay = ({ data = [] }) => {
  // Test data with 5 items (mix of images and PDFs)

  const [previewItem, setPreviewItem] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  const handlePreview = (item) => {
    setPreviewItem(item);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setPreviewItem(null);
  };

  const handleDownload = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.download = filename || "download";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box p={4}>
      {data.length === 0 ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="200px"
        >
          <Typography variant="subtitle1" color="textSecondary">
            No reports available.
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={2}>
          {data.map((item) => (
            <Grid item xs={6} sm={4} md={3} key={item.id}>
              <Card
                elevation={0}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  border: "1px solid #eef0f3",
                  borderRadius: 12,
                  overflow: "hidden",
                }}
              >
                {item.type === "image" ? (
                  <ReportImageCard handlePreview={handlePreview} item={item} />
                ) : (
                  <Box
                    style={{
                      position: "relative",
                      width: "100%",
                      paddingTop: "100%", // square aspect ratio
                      backgroundColor: "#f5f5f5",
                      cursor: "pointer",
                    }}
                    onClick={() => handleDownload(item.url, item.title)}
                  >
                    <img
                      src={pdfFileIcon}
                      alt={item.title}
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "52%",
                        height: "52%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                )}

                <Typography
                  variant="subtitle1"
                  style={{ margin: 5, marginLeft: 10 }}
                  noWrap
                >
                  {item.title}
                </Typography>

                <Box p={1} display="flex" justifyContent="space-between">
                  <Button
                    size="small"
                    color="primary"
                    startIcon={<Visibility />}
                    onClick={() =>
                      item.type === "image"
                        ? handlePreview(item)
                        : handleDownload(item.url, item.title)
                    }
                  ></Button>
                  <Button
                    size="small"
                    color="secondary"
                    startIcon={<GetApp />}
                    onClick={() => handleDownload(item.url, item.title)}
                  ></Button>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
      {/* Preview Dialog */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          {previewItem?.title}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {previewItem?.type === "image" && (
            <Box
              style={{
                width: "100%",
                height: "70vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <ReportImagePreviewItem
                url={previewItem.url}
                title={previewItem.title}
              />
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ReportDisplay;
